import React, { useState, useEffect } from "react";
import moment from "moment";

const DisplayRow = ({orderItems}) => {
  const [time, setTime] = useState("");

  useEffect(() => {
    setInterval(function() {
      let secs = moment().diff(orderItems.data.now, 'seconds');
      let timeWaited = moment.utc(secs*1000).format('HH:mm:ss')
      setTime(timeWaited)
  }, 1 * 1000); // 1 * 1000 milsec
  }, [orderItems]);


  return (
    <>
               <div className="row">
                <table className="order-category-wrapper striped left">
                  <tbody>
                    <tr key={orderItems.ticketId}>
                      <td className="table-col">{orderItems.data.userName}</td>
                      <td className="table-col">{orderItems.data.title}</td>
                      <td className="table-col">
                        {orderItems.data.displayNow}
                      </td>
                      <td className="table-col">{time}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
           
    </>
  );
};

export default DisplayRow;
